# Note: to use this, place amount-focus-on-first-error directive on forms
# or other elements that contain inputs that will be validated at some point. 
# Then broadcast the "form:invalid" as needed. 
angular.module("avant.customer_applications.directives").directive "amountFocusOnFirstError", () ->
  link: (scope, element, attr) ->
    scope.focusOnFirstError = (elem) ->
      elem.find(".ng-invalid")[0]?.focus()
    scope.$on("form:invalid", () ->
      scope.focusOnFirstError(element)
    )
